import Pikaday from "pikaday";

Array.from(document.querySelectorAll(".js-date-picker")).forEach((element) => {
  new Pikaday({ field: element });
});
